const runtimeConfig = { env: {}, cognito: {}, whitelabel: {} };

export const setRuntimeConfig = (key, value) => {
  runtimeConfig[key] = value;
};

export const getRuntimeConfig = () => runtimeConfig;
